import { useEffect, useReducer } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { isVeteransDayChallengeVisible } from '../utils/utils';
import {
  VETERANS_DAY_CHALLENGE_START_KEY,
  VETERANS_DAY_CHALLENGE_END_KEY,
} from '../constants/veteran-day-challenge';

/* How often an open page re-checks the clock against the challenge window. */
export const VETERANS_DAY_CHALLENGE_RECHECK_MS = 30 * 1000;

/* The window is read against the clock at render, so a page left open across
/* the start or the end would otherwise keep its old answer until something else
/* re-rendered it. The clock is re-checked on an interval and whenever a hidden
/* tab comes back (browsers throttle timers in the background), and the hook only
/* re-renders when the answer actually flips. */
export const useVeteransDayChallenge = (registeredAt) => {
  const challengeStart = useConfigService(VETERANS_DAY_CHALLENGE_START_KEY);
  const challengeEnd = useConfigService(VETERANS_DAY_CHALLENGE_END_KEY);
  const [, rerender] = useReducer((count) => count + 1, 0);

  const isVisible = isVeteransDayChallengeVisible({
    registeredAt,
    challengeStart,
    challengeEnd,
  });

  useEffect(() => {
    const recheck = () => {
      const isVisibleNow = isVeteransDayChallengeVisible({
        registeredAt,
        challengeStart,
        challengeEnd,
      });
      if (isVisibleNow !== isVisible) {
        rerender();
      }
    };
    const recheckWhenShown = () => {
      if (document.visibilityState === 'visible') {
        recheck();
      }
    };
    const interval = setInterval(recheck, VETERANS_DAY_CHALLENGE_RECHECK_MS);
    document.addEventListener('visibilitychange', recheckWhenShown);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', recheckWhenShown);
    };
  }, [registeredAt, challengeStart, challengeEnd, isVisible]);

  return isVisible;
};
